import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cvv-popup',
  templateUrl: './cvv-popup.component.html',
  styleUrls: ['./cvv-popup.component.scss']
})
export class CVVPopupComponent {
cvv:string='';
tooltipVisibleForCashInfo: boolean = false;
  constructor(
    private dialog: MatDialogRef<CVVPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
this.cvv='';
  }

  ngOnInit() {}

  close() {
    this.dialog.close('');
  }

  addCVV() {
    this.dialog.close(this.cvv);
  }
  showTooltip(): void {
    this.tooltipVisibleForCashInfo = true;
}
hideTooltip(): void {
  this.tooltipVisibleForCashInfo= false;
}
}
